import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getUserLocationCookie } from 'commons/localStorage';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import useZipCode from 'global-state/zipCode/useZipCode';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import { PDP_READYTOSHIP_TAB_ID } from '../../commons/constants';
import { GET_PRODUCT_OPTIONS_LEAD_TIMES } from './queries';
const getLeadTimeErrorText = leadTimeError => leadTimeError?.code === '90001' ? 'Option currently not available' : leadTimeError?.message;
const getLeadTimeText = leadTime => leadTime > 7 ? ` ${Math.round(leadTime / 7)} weeks` : ` ${leadTime} days`;
const usePDPLeadTime = () => {
  const $ = _c(16);
  const zipCode = useZipCode();
  const {
    data: productBasicData
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const {
    loading: productOptionsLoading,
    data: t0
  } = usePDPOptions();
  const {
    selectedOptions
  } = t0;
  const [getProductLeadTimes, t1] = useLazyQuery(GET_PRODUCT_OPTIONS_LEAD_TIMES);
  const {
    loading: leadTimeLoading,
    data: leadTimesResponse
  } = t1;
  const productId = productBasicData?.id;
  let t2;
  bb0: {
    if (leadTimesResponse?.getProductOptionsLeadTime) {
      const {
        getProductOptionsLeadTime: leadTimesData
      } = leadTimesResponse;
      if (leadTimesData.errors?.length) {
        const t3 = leadTimesData?.error[0];
        let t4;
        if ($[0] !== t3) {
          t4 = getLeadTimeErrorText(t3);
          $[0] = t3;
          $[1] = t4;
        } else {
          t4 = $[1];
        }
        t2 = t4;
        break bb0;
      }
      const t3 = leadTimesData?.lead_time;
      let t4;
      if ($[2] !== t3) {
        t4 = getLeadTimeText(t3);
        $[2] = t3;
        $[3] = t4;
      } else {
        t4 = $[3];
      }
      t2 = t4;
      break bb0;
    }
    t2 = "";
  }
  const shippingLeadTime = t2;
  let t3;
  let t4;
  if ($[4] !== getProductLeadTimes || $[5] !== leadTimeLoading || $[6] !== pdpSelectedCustomizerTab || $[7] !== productId || $[8] !== productOptionsLoading || $[9] !== selectedOptions || $[10] !== zipCode) {
    t3 = () => {
      if (!zipCode || productOptionsLoading || leadTimeLoading || !productId) {
        return;
      }
      const stockForOptions = {};
      Object.keys(selectedOptions).forEach(optId => {
        stockForOptions[optId] = [selectedOptions[optId]];
      });
      const userLocation = getUserLocationCookie();
      getProductLeadTimes({
        variables: {
          id: productId,
          zipcode: userLocation.zip ? userLocation.zip.toString() : "",
          options: JSON.stringify(stockForOptions),
          noCache: pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID
        }
      });
    };
    t4 = [getProductLeadTimes, leadTimeLoading, pdpSelectedCustomizerTab, productId, productOptionsLoading, selectedOptions, zipCode];
    $[4] = getProductLeadTimes;
    $[5] = leadTimeLoading;
    $[6] = pdpSelectedCustomizerTab;
    $[7] = productId;
    $[8] = productOptionsLoading;
    $[9] = selectedOptions;
    $[10] = zipCode;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  useEffect(t3, t4);
  let t5;
  if ($[13] !== leadTimeLoading || $[14] !== shippingLeadTime) {
    t5 = {
      shippingLeadTime,
      leadTimeLoading
    };
    $[13] = leadTimeLoading;
    $[14] = shippingLeadTime;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default usePDPLeadTime;